import React from "react";
import Button from "@/components/atomics/button";
import ModalCard from "@/components/atomics/modal-card";

interface ShareModalProps {
  isLoading: boolean;
  onClose: () => void;
  onShareToStory: () => void;
  onShareToTelegram: () => void;
}

export default function ShareModal({
  isLoading,
  onClose,
  onShareToStory,
  onShareToTelegram,
}: ShareModalProps) {
  return (
    <ModalCard title="share link" onClose={onClose}>
      <div className="flex flex-col gap-8 px-[50px] pt-[80px] pb-[60px]">
        {/* <Button
          className="w-full text-[24px] transition-transform duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed"
          image="/assets/button.svg"
          text="SEND TO STORIES"
          onClick={onShareToStory}
          disabled={true}
        /> */}
        <Button
          className="w-full text-[24px] hover:cursor-pointer hover:scale-102 transition-transform duration-300 ease-in-out disabled:opacity-50"
          image="/assets/button.svg"
          text={isLoading ? "SHARING..." : "SEND TO TELEGRAM"}
          onClick={onShareToTelegram}
          disabled={isLoading}
        />
      </div>
    </ModalCard>
  );
}
